import { useState, useEffect, useContext } from "react";
import LazyLoad from "react-lazy-load";
import CollectionButton from "./CollectionButton";
import ToolTip from "./ToolTip";
import { MaterialContext } from "../context/MaterialContext";
import { UserContext } from "../context/UserContext";
import { nikeLogo } from "./Icons";

import swatchStyle from "../styles/swatch.module.scss";

import MaterialModal from "./MaterialModal";

function Swatch({ id }) {
  const { allMaterials, nikeData, changeSearch, ROOT_SERVER } =
    useContext(MaterialContext);
  const { userInformation, media } = useContext(UserContext);

  const [materialData, setMaterialData] = useState(null);
  const [viewing, setViewing] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageNumber, setImageNumber] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isNike, setIsNike] = useState(false);
  const [brandData, setBrandData] = useState([]);
  const [showToolTip, setShowToolTip] = useState(false);

  const showLogo =
    userInformation.vendor === "asiatan" || userInformation.vendor === "nike";

  const showCount =
    userInformation.vendor === "asiatan" ||
    userInformation.vendor === "tectuff";

  useEffect(() => {
    if (!id) {
      return;
    }

    const getMaterial = allMaterials.find((material) => material.id === id);
    if (!getMaterial) {
      setMaterialData(null);
      return;
    }

    setMaterialData(getMaterial);
    const getNikeData = nikeData.filter(
      (item) => item?.slug === getMaterial.slug,
    );
    setIsNike(getNikeData.length > 0);
    setBrandData(getNikeData);

    const materialImages = Array.isArray(getMaterial.images)
      ? getMaterial.images
      : [];
    const safeImage = materialImages[imageNumber] || materialImages[0] || "";
    setViewing(
      `${ROOT_SERVER}${getMaterial.vendor}/${getMaterial.slug}/swatch/${safeImage}`,
    );
  }, [allMaterials, imageNumber, id, nikeData, ROOT_SERVER]);

  const handleChangeImage = (i) => {
    setImageLoaded(false);
    setImageNumber(i);
  };
  const handleImageLoaded = () => {
    setImageLoaded(true);
  };
  const handleShowModal = () => {
    setShowModal(true);
  };

  if (!materialData) {
    return null;
  }

  const { title, description, vendor, slug, images, view_count } = materialData;

  return (
    <>
      {showModal && (
        <MaterialModal
          id={id}
          showModal={showModal}
          setShowModal={setShowModal}
          brandData={brandData}
          userInformation={userInformation}
          media={media}
          imageNum={imageNumber}
        />
      )}
      <div className={swatchStyle.swatch} data-id={id}>
        <LazyLoad offset={200} threshold={1}>
          <img
            onClick={handleShowModal}
            className={
              imageLoaded
                ? `${swatchStyle.imageBlur} ${swatchStyle.loaded}`
                : `${swatchStyle.imageBlur}`
            }
            src={viewing}
            alt={slug}
            onLoad={handleImageLoaded}
          />
        </LazyLoad>
        <div className={swatchStyle.vendor}>
          <p
            className={swatchStyle.vendorLabel}
            onClick={() => changeSearch(vendor)}
          >
            {vendor}
          </p>
          {showCount ? <p>views: {view_count}</p> : null}
          {isNike && showLogo ? (
            <div
              className={swatchStyle.logo}
              onMouseOver={() => setShowToolTip(true)}
              onMouseLeave={() => setShowToolTip(false)}
            >
              {nikeLogo}
              <ToolTip
                brandData={brandData.filter((item) => item.slug === slug)}
                setShowToolTip={setShowToolTip}
                showToolTip={showToolTip}
                brand={userInformation.vendor}
              />
            </div>
          ) : (
            false
          )}
        </div>
        <div className={swatchStyle.collectionButton}>
          <CollectionButton materialId={id} />
        </div>

        {images?.length >= 2 && (
          <div className={swatchStyle.imageSelector}>
            {images?.map((image, i) => (
              <span
                key={image}
                onClick={() => handleChangeImage(i)}
                style={
                  imageNumber === i
                    ? { background: "transparent" }
                    : { background: "#FEFEFE90" }
                }
              />
            ))}
          </div>
        )}

        <div className={swatchStyle.information}>
          {!imageLoaded && <div className={swatchStyle.loadingBar} />}
          <h3>{title}</h3>
          <h4>{description}</h4>
        </div>
      </div>
    </>
  );
}

export default Swatch;
